import DashboardLayout from './layout'

function UsersPage() {
  return (
    <div>
      <DashboardLayout title={''} children={undefined} />
      <h1>Users page</h1>
    </div>
  )
}

export default UsersPage
